import type {FeatureCollectionsState, StateSlice} from '@src/stores/types.ts';
import type {
  FeatureCollectionId,
  FeatureRef,
} from '@src/types/featureCollections.ts';

const initialState = {
  // The feature ref to show details for
  featureDetailsRef: null,

  // The currently selected features.
  selectedFeatureRefs: [],

  // The hash ID of the currently visible collection.
  visibleCollectionId: null,
};

export const setFeatureCollectionsSlice: StateSlice<
  FeatureCollectionsState
> = set => ({
  ...initialState,
  selectCollectionFeatureRefs: (featureRefs: FeatureRef[]) =>
    set(
      state => {
        state.featureCollections.selectedFeatureRefs = featureRefs;
      },
      undefined,
      'featureCollections/selectCollectionFeatureRefs',
    ),
  setFeatureDetailsRef: (featureRef: FeatureRef | null) =>
    set(
      state => {
        state.featureCollections.featureDetailsRef = featureRef;
      },
      undefined,
      'featureCollections/setFeatureDetailsRef',
    ),
  setVisibleCollection: (collectionId: FeatureCollectionId | null) =>
    set(
      state => {
        state.featureCollections.visibleCollectionId = collectionId;
      },
      undefined,
      'featureCollections/setVisibleCollection',
    ),
});
